import { render, staticRenderFns } from "./SidebarWidget.vue?vue&type=template&id=2f694c3f&lang=pug&"
import script from "./SidebarWidget.vue?vue&type=script&lang=js&"
export * from "./SidebarWidget.vue?vue&type=script&lang=js&"
import style0 from "./SidebarWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports